import { displayFnWrapperArrayFlatter } from './common-display-fn';

export const emeaCommonFloorSizeFunctions = {
  420: {
    // 420 - common floor size (Poland & Finland)
    displayFn: displayFnWrapperArrayFlatter,
  },
  430: {
    // 430 - common floor size (Italy)
    displayFn: displayFnWrapperArrayFlatter,
  },
  507: {
    // 507 - common floor size (Norway)
    displayFn: displayFnWrapperArrayFlatter,
  },
  517: {
    // 517 - common floor size (Norway)
    displayFn: displayFnWrapperArrayFlatter,
  },
  497: {
    // 497 - common floor size (Sweden)
    displayFn: displayFnWrapperArrayFlatter,
  },
};
